import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { TenantProvider, useTenant } from "@/context/TenantContext";
import ErrorBoundary from "@/components/ErrorBoundary";
import Login from "@/pages/Login";
import Landing from "@/pages/Landing";
import Store from "@/pages/Store";
import Reportes from "@/pages/Reportes";
import Codigos from "@/pages/Codigos";
import AdminPanel from "@/pages/AdminPanel";
import LinkEmailGate from "@/components/LinkEmailGate";

function Protected({ children, role }) {
  const { user, loading } = useAuth();
  const { tenant } = useTenant();
  if (loading) return <div className="min-h-screen grid place-items-center text-red-600 font-head text-xl">Cargando MQ Store...</div>;
  if (!user) return <Navigate to="/login" replace />;
  // Vincular un correo real es obligatorio -- sin esto no hay forma de
  // recuperar la cuenta si se olvida la contraseña. Bloquea cualquier ruta
  // protegida (tienda, reportes, admin) hasta que se cumpla -- pero solo si
  // ESTA tienda de verdad puede mandar el código (email_enabled, ver
  // /tenant/config): si no tiene Resend configurado, exigirlo dejaría a
  // todos sus clientes atrapados pidiendo un código que nunca les llega.
  if (!user.real_email && tenant?.email_enabled) return <LinkEmailGate />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <TenantProvider>
          <AuthProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/" element={<Landing />} />
                <Route path="/compras" element={<Protected><Store /></Protected>} />
                <Route path="/reportes" element={<Protected><Reportes /></Protected>} />
                <Route path="/codigos" element={<Protected><Codigos /></Protected>} />
                <Route path="/admin" element={<Protected role="admin"><AdminPanel /></Protected>} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </BrowserRouter>
            <Toaster position="bottom-left" richColors />
          </AuthProvider>
        </TenantProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
